export default "__VITE_ASSET__cf845cb0__"